module.exports = __webpack_public_path__ + "media/pourquoi_donner/planete-db797a14.png";